module.exports = __webpack_public_path__ + "img/current-account.4c325b9.png";